import { useEffect, useState } from "react";


// Este hook permite mostrar una lista de items de forma progresiva,
// cargando más items a medida que el navegador tiene tiempo libre (usando requestIdleCallback). 
// Es útil para listas largas donde no queremos bloquear el hilo principal cargando todo de golpe.

export function useProgressiveList(items, batchSize = 5) {
  const [visibleCount, setVisibleCount] = useState(batchSize);

  useEffect(() => {
    setVisibleCount(batchSize); // reset al cambiar la lista
  }, [items]);

  useEffect(() => {
    if (visibleCount >= items.length) return;

    const id = requestIdleCallback(
      () => setVisibleCount(prev => Math.min(prev + batchSize, items.length)),
      { timeout: 300 }
    );

    return () => cancelIdleCallback(id);
  }, [visibleCount, items.length, batchSize]);

  return items.slice(0, visibleCount);
}